var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"alert alert-info text-center my-3"},[_c('i',{staticClass:"bi bi-info-circle me-1"}),_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }